import { expansionOptionActionTypes } from 'shared/expansionOptions';

export default {
  CHANGE_ROUTE: 'raidbots/simbot/change_route',

  SHOW_OVERLAY: 'raidbots/site/show_overlay',
  CLEAR_OVERLAY: 'raidbots/site/clear_overlay',

  // gearsets
  ADD_GEARSET: 'raidbots/simbot/gearsets/add',
  REMOVE_GEARSET: 'raidbots/simbot/gearsets/remove',
  DUPLICATE_GEARSET: 'raidbots/simbot/gearsets/duplicate',

  // items
  ADD_ITEM: 'raidbots/simbot/gearset/add',
  REMOVE_ITEM: 'raidbots/simbot/gearset/remove',
  INPUT_GEARSET_NAME: 'raidbots/simbot/gearset/input_name',
  SAVE_GEARSET: 'raidbots/simbot/saved_gearset/save',
  DELETE_SAVED_GEARSET: 'raidbots/simbot/saved_gearset/delete',
  CHOOSE_SAVED_GEARSET: 'raidbots/simbot/saved_gearset/choose',

  // item
  INPUT_ITEM: 'raidbots/simbot/item/input',
  INPUT_ITEM_SLOT: 'raidbots/simbot/item/slot',
  INPUT_ITEM_LEVEL: 'raidbots/simbot/item/input_item_level',
  INPUT_ITEM_GEM: 'raidbots/simbot/item/input_gem',
  INPUT_ITEM_GEM_LEVEL: 'raidbots/simbot/item/input_gem_level',
  INPUT_ITEM_ENCHANT: 'raidbots/simbot/item/input_enchant',
  INPUT_ITEM_SECONDARY: 'raidbots/simbot/item/input_secondary',
  INPUT_ITEM_AFFIX: 'raidbots/simbot/item/input_affix',
  INPUT_ITEM_HAND: 'raidbots/simbot/item/input_hand',
  INPUT_ITEM_AZERITE_POWER: 'raidbots/simbot/item/input_azerite_power',
  INPUT_ITEM_CORRUPTION: 'raidbots/simbot/item/input_corruption',
  INPUT_ITEM_LEGENDARY_POWER: 'raidbots/simbot/item/input_legendary_power',
  INPUT_ITEM_LEGENDARY_STATS: 'raidbots/simbot/item/input_legendary_stats',
  INPUT_ITEM_CRAFTED_STATS: 'raidbots/simbot/item/input_crafted_stats',

  // relic
  ADD_RELIC_SET: 'raidbots/simbot/relics_set/add',
  REMOVE_RELIC_SET: 'raidbots/simbot/relics_set/remove',
  DUPLICATE_RELIC_SET: 'raidbots/simbot/relics_set/duplicate',

  INPUT_RELIC: 'raidbots/simbot/relic/input',
  INPUT_RELIC_LEVEL: 'raidbots/simbot/relic/input_level',
  CHOOSE_RELIC_CRUCIBLE: 'raidbots/simbot/relic/choose_relic_crucible',

  // talents
  ADD_TALENT_SET: 'raidbots/simbot/talent_set/add',
  DUPLICATE_TALENT_SET: 'raidbots/simbot/talent_set/duplicate',
  REMOVE_TALENT_SET: 'raidbots/simbot/talent_set/remove',

  CHOOSE_TALENT: 'raidbots/simbot/talent/choose',
  INPUT_TALENT_SET_NAME: 'raidbots/simbot/talent/input_name',

  // form
  INPUT_REPORT_NAME: 'raidbots/simbot/form/input_report_name',
  INPUT_FORM: 'raidbots/simbot/form/input',
  CLEAR_FORM: 'raidbots/simbot/form/clear',
  FORM_ERROR: 'raidbots/simbot/form/form_error',
  SUBMIT_SIM_REQUEST: 'raidbots/simbot/form/submit_sim_request',
  SUBMIT_SIM_SUCCESS: 'raidbots/simbot/form/submit_sim_success',
  SUBMIT_SIM_FAILURE: 'raidbots/simbot/form/submit_sim_failure',
  TOGGLE_EMAIL: 'raidbots/simbot/form/toggle_email',
  TOGGLE_BROWSER_NOTIFICATION: 'raidbots/simbot/form/toggle_browser_notification',
  TOGGLE_TALENTS_OVERRIDE_OVERLAY: 'raidbots/simbot/toggle_talents_override_overlay',
  CHOOSE_TALENTS_OVERRIDE: 'raidbots/simbot/form/choose_talents_override',
  CONVERT_TO_PROFILESETS: 'raidbots/simbot/form/convert_to_profilesets',

  CANCEL_SIM: 'raidbots/simbot/cancel_sim',

  // optimize gear
  INPUT_OPTIMIZE_TEXT: 'raidbots/simbot/input_optimize_text',
  SET_OPTIMIZE_TEXT: 'raidbots/simbot/set_optimize_text',
  SET_OPTIMIZE_LOADING: 'raidbots/simbot/set_optimize_loading',

  FETCH_COMBINATIONS_REQUEST: 'raidbots/simbot/fetch_combinations_request',
  FETCH_COMBINATIONS_SUCCESS: 'raidbots/simbot/fetch_combinations_success',
  FETCH_COMBINATIONS_FAILURE: 'raidbots/simbot/fetch_combinations_failure',

  FETCH_GEAR_INFO_REQUEST: 'raidbots/simbot/fetch_gear_info_request',
  FETCH_GEAR_INFO_SUCCESS: 'raidbots/simbot/fetch_gear_info_success',
  FETCH_GEAR_INFO_FAILURE: 'raidbots/simbot/fetch_gear_info_failure',

  ADD_OPTIMIZE_ITEM: 'raidbots/simbot/add_optimize_item',
  REMOVE_OPTIMIZE_ITEM: 'raidbots/simbot/remove_optimize_item',

  FETCH_OPTIMIZE_CUSTOM_ITEMS_REQUEST: 'raidbots/simbot/fetch_optimize_custom_items_request',
  FETCH_OPTIMIZE_CUSTOM_ITEMS_SUCCESS: 'raidbots/simbot/fetch_optimize_custom_items_success',
  FETCH_OPTIMIZE_CUSTOM_ITEMS_FAILURE: 'raidbots/simbot/fetch_optimize_custom_items_failure',

  RESET_OPTIMIZE: 'raidbots/simbot/reset_optimize',
  TOGGLE_COMBINATION_ITEM: 'raidbots/simbot/toggle_combination_item',
  TOGGLE_OPTIMIZE_AZERITE_POWER: 'raidbots/simbot/toggle_optimize_azerite_power',
  TOGGLE_REQUIRE_LEGENDARIES: 'raidbots/simbot/toggle_require_legendaries',

  CHOOSE_TIER_21_CONSTRAINT: 'raidbots/simbot/choose_tier_21_constraint',
  CHOOSE_TIER_20_CONSTRAINT: 'raidbots/simbot/choose_tier_20_constraint',
  CHOOSE_TIER_19_CONSTRAINT: 'raidbots/simbot/choose_tier_19_constraint',

  CHOOSE_OPTIMIZE_MIN_CORRUPTION: 'raidbots/simbot/choose_optimize_min_corruption',
  CHOOSE_OPTIMIZE_MAX_CORRUPTION: 'raidbots/simbot/choose_optimize_max_corruption',
  TOGGLE_OPTIMIZE_TRY_PURIFICATION: 'raidbots/simbot/choose_optimize_try_purification',
  TOGGLE_OPTIMIZE_IGNORE_LOW_CORRUPTION: 'raidbots/simbot/toggle_optimize_ignore_low_corruption',
  CHOOSE_OPTIMIZE_PURIFY_MODE: 'raidbots/simbot/choose_optimize_purify_mode',

  CHOOSE_OPTIMIZE_GEM: 'raidbots/simbot/choose_optimize_gem',
  CHOOSE_OPTIMIZE_CLOAK_ENCHANT: 'raidbots/simbot/choose_optimize_cloak_enchant',
  CHOOSE_OPTIMIZE_RING_ENCHANT: 'raidbots/simbot/choose_optimize_ring_enchant',
  CHOOSE_OPTIMIZE_NECK_ENCHANT: 'raidbots/simbot/choose_optimize_neck_enchant',
  CHOOSE_OPTIMIZE_WEAPON_ENCHANT: 'raidbots/simbot/choose_optimize_weapon_enchant',
  CHOOSE_OPTIMIZE_WEAPON_OH_ENCHANT: 'raidbots/simbot/choose_optimize_weapon_oh_enchant',
  CHOOSE_OPTIMIZE_REPLACE_EXISTING: 'raidbots/simbot/choose_optimize_replace_existing',
  TOGGLE_OPTIMIZE_USE_MAIN_STAT_GEM: 'raidbots/simbot/toggle_optimize_use_main_stat_gem',
  TOGGLE_LOCK: 'raidbots/simbot/toggle_lock',
  TOGGLE_TALENT_RING_OVERRIDE: 'raidbots/simbot/toggle_talent_ring_override',
  TOGGLE_OPTIMIZE_HIDE_LOW_LEVEL: 'raidbots/simbot/toggle_optimize_hide_low_level',
  TOGGLE_OPTIMIZE_HIDE_OFFSPEC_AZERITE_POWERS: 'raidbots/simbot/toggle_optimize_hide_offspec_azerite_powers',
  TOGGLE_PURIFY: 'raidbots/simbot/toggle_purify',

  TOGGLE_OPTIMIZE_ENHANCEMENT_ADVANCED_CONTROLS: 'raidbots/simbot/toggle_optimize_enhancement_advanced_controls',
  TOGGLE_OPTIMIZE_ENHANCEMENT_REPLACE: 'raidbots/simbot/toggle_optimize_enhancement_replace',
  TOGGLE_OPTIMIZE_ENHANCEMENT: 'raidbots/simbot/toggle_optimize_enhancement',
  CLEAR_OPTIMIZE_ENHANCEMENTS: 'raidbots/simbot/clear_optimize_enhancements',
  SET_OPTIMIZE_ENHANCEMENTS_DEFAULT: 'raidbots/simbot/set_optimize_enhancements_default',
  SET_OPTIMIZE_ENHANCEMENT_WRATHION_SOCKET: 'raidbots/simbot/set_optimize_enhancement_wrathion_socket',

  CHOOSE_OPTIMIZE_ADD_SOCKET_NUM: 'raidbots/simbot/choose_optimize_add_socket_num',
  CHOOSE_OPTIMIZE_ADD_SOCKET_GEM: 'raidbots/simbot/choose_optimize_add_socket_gem',

  TOGGLE_OPTIMIZE_TALENT: 'raidbots/simbot/toggle_optimize_talent',
  TOGGLE_OPTIMIZE_LOCKED_TALENT: 'raidbots/simbot/toggle_optimize_locked_talent',
  TOGGLE_OPTIMIZE_ADVANCED_TALENT_CONTROLS: 'raidbots/simbot/toggle_optimize_advanced_talent_controls',
  RESET_OPTIMIZE_TALENTS: 'raidbots/simbot/reset_optimize_talents',
  SET_OPTIMIZE_TALENTS: 'raidbots/simbot/set_optimize_talents',
  TOGGLE_OPTIMIZE_ENHANCEMENTS_MAIN_STAT_GEM: 'raidbots/simbot/toggle_optimize_enhancements_main_stat_gem',
  CHOOSE_CONTAMINANT_COUNT: 'raidbots/simbot/choose_contaminant_count',

  TOGGLE_OPTIMIZE_ESSENCE: 'raidbots/simbot/toggle_optimize_essence',
  TOGGLE_OPTIMIZE_ESSENCE_MINOR_LOCK: 'raidbots/simbot/toggle_optimize_essence_minor_lock',
  TOGGLE_OPTIMIZE_ESSENCE_ADVANCED_CONTROLS: 'raidbots/simbot/toggle_optimize_essence_advanced_controls',
  SET_OPTIMIZE_ESSENCE_RANK: 'raidbots/simbot/set_optimize_essence_rank',

  SET_OPTIMIZE_ALL_SOULBINDS: 'raidbots/simbot/set_optimize_all_soulbinds',
  SET_OPTIMIZE_ALL_CONDUITS: 'raidbots/simbot/set_optimize_all_conduits',
  SET_OPTIMIZE_ALL_COVENANTS: 'raidbots/simbot/set_optimize_all_covenants',
  TOGGLE_OPTIMIZE_SOULBIND: 'raidbots/simbot/toggle_optimize_soulbind',
  TOGGLE_OPTIMIZE_SOULBIND_GROUP: 'raidbots/simbot/toggle_optimize_soulbind_group',
  TOGGLE_OPTIMIZE_CONDUIT: 'raidbots/simbot/toggle_optimize_conduit',
  CHOOSE_CONDUIT_RANK_OVERRIDE: 'raidbots/simbot/choose_conduit_rank_override',

  SELECT_OPTIMIZE_ITEMS: 'raidbots/simbot/select_optimize_items',

  // droptimizer
  TOGGLE_DROPTIMIZER_INSTANCE: 'raidbots/simbot/toggle_droptimizer_instance',
  CHOOSE_DROPTIMIZER_INSTANCE: 'raidbots/simbot/choose_droptimizer_instance',
  CHOOSE_DROPTIMIZER_ENCOUNTER: 'raidbots/simbot/choose_droptimizer_encounter',
  CHOOSE_DROPTIMIZER_DIFFICULTY: 'raidbots/simbot/choose_droptimizer_difficulty',
  CHOOSE_DROPTIMIZER_GROUP_BY: 'raidbots/simbot/choose_droptimizer_group_by',
  TOGGLE_DROPTIMIZER_ALL_AZERITE_POWERS: 'raidbots/simbot/toggle_droptimizer_all_azerite_powers',
  CHOOSE_DROPTIMIZER_WARFORGE_LEVEL: 'raidbots/simbot/choose_droptimizer_warforge_level',
  CHOOSE_DROPTIMIZER_GEM: 'raidbots/simbot/choose_droptimizer_gem',
  CHOOSE_DROPTIMIZER_CORRUPTION: 'raidbots/simbot/choose_droptimizer_corruption',
  CHOOSE_DROPTIMIZER_LOOT_SPEC: 'raidbots/simbot/choose_droptimizer_loot_spec',
  TOGGLE_DROPTIMIZER_SHOW_PREVIOUS_TIERS: 'raidbots/simbot/toggle_droptimizer_show_previous_tiers',

  // jobs
  REMOVE_JOB: 'raidbots/simbot/jobs/remove_job',

  // character
  FETCH_CHAR_REQUEST: 'raidbots/simbot/form/fetch_char_request',
  FETCH_CHAR_SUCCESS: 'raidbots/simbot/form/fetch_char_success',
  FETCH_CHAR_FAILURE: 'raidbots/simbot/form/fetch_char_failure',
  FETCH_CHAR_CANCELLED: 'raidbots/simbot/form/fetch_char_cancelled',

  // realms
  FETCH_REALMS_REQUEST: 'raidbots/simbot/fetch_realms_request',
  FETCH_REALMS_SUCCESS: 'raidbots/simbot/fetch_realms_success',
  FETCH_REALMS_FAILURE: 'raidbots/simbot/fetch_realms_failure',

  // sims
  FETCH_SIMS_REQUEST: 'raidbots/simbot/fetch_sims_request',
  FETCH_SIMS_SUCCESS: 'raidbots/simbot/fetch_sims_success',
  FETCH_SIMS_FAILURE: 'raidbots/simbot/fetch_sims_failure',

  // simc items
  FETCH_SIMC_ITEMS_REQUEST: 'raidbots/simbot/fetch_simc_input_request',
  FETCH_SIMC_ITEMS_SUCCESS: 'raidbots/simbot/fetch_simc_input_success',
  FETCH_SIMC_ITEMS_FAILURE: 'raidbots/simbot/fetch_simc_input_failure',

  CHOOSE_ALTERNATE_WEAPON: 'raidbots/simbot/choose_alternate_weapon',

  // simc options
  TOGGLE_ADVANCED_OPTIONS: 'raidbots/simbot/toggle_advanced_options',
  SELECT_SIMC_VERSION: 'raidbots/simbot/select_simc_version',
  SELECT_ITERATIONS: 'raidbots/simbot/select_iterations',
  SELECT_FIGHT_STYLE: 'raidbots/simbot/select_fight_style',
  SELECT_FIGHT_LENGTH: 'raidbots/simbot/select_fight_length',
  SELECT_ENEMY_COUNT: 'raidbots/simbot/select_enemy_count',
  SELECT_ENEMY_TYPE: 'raidbots/simbot/select_enemy_type',
  SELECT_POTION: 'raidbots/simbot/select_potion',
  SELECT_FOOD: 'raidbots/simbot/select_food',
  SELECT_FLASK: 'raidbots/simbot/select_flask',
  SELECT_PANTHEON_TRINKETS: 'raidbots/simbot/select_pantheon_trinkets',
  SELECT_AUGMENTATION: 'raidbots/simbot/select_augmentation',
  TOGGLE_OPTIMAL_RAID: 'raidbots/simbot/toggle_optimal_raid',
  TOGGLE_SMART_HIGH_PRECISION: 'raidbots/simbot/toggle_smart_high_precision',

  TOGGLE_BLOODLUST: 'raidbots/simbot/toggle_bloodlust',
  TOGGLE_ARCANE_INTELLECT: 'raidbots/simbot/toggle_arcane_intellect',
  TOGGLE_FORTITUDE: 'raidbots/simbot/toggle_fortitude',
  TOGGLE_BATTLE_SHOUT: 'raidbots/simbot/toggle_battle_shout',
  TOGGLE_MYSTIC_TOUCH: 'raidbots/simbot/toggle_mystic_touch',
  TOGGLE_CHAOS_BRAND: 'raidbots/simbot/toggle_chaos_brand',
  TOGGLE_BLEEDING: 'raidbots/simbot/toggle_bleeding',
  TOGGLE_WINDFURY: 'raidbots/simbot/toggle_windfury',

  SET_REORIGINATION_ARRAY: 'raidbots/simbot/set_reorigination_array',
  TOGGLE_ZULDAZAR: 'raidbots/simbot/toggle_zuldazar',
  TOGGLE_NAZJATAR: 'raidbots/simbot/toggle_nazjatar',
  TOGGLE_ABERRATION: 'raidbots/simbot/toggle_aberration',
  SET_WORLDVEIN_ALLIES: 'raidbots/simbot/set_worldvein_allies',
  SET_LOYAL_TO_END_END_ALLIES: 'raidbots/simbot/set_loyal_to_the_end_allies',
  SET_UNDULATING_LOCKOUT: 'raidbots/simbot/set_undulating_lockout',
  SET_COVENANT_CHANCE: 'raidbots/simbot/set_covenant_chance',
  TOGGLE_NYALOTHA: 'raidbots/simbot/toggle_nyalotha',
  SET_SURGING_VITALITY: 'raidbots/simbot/set_surging_vitality',
  SET_SYMBIOTIC_PRESENCE: 'raidbots/simbot/set_symbiotic_presence',
  TOGGLE_VOID_RITUAL: 'raidbots/simbot/toggle_void_ritual',

  TOGGLE_PTR: 'raidbots/simbot/toggle_ptr',
  TOGGLE_REPORT_DETAILS: 'raidbots/simbot/toggle_report_details',
  TOGGLE_SHOW_ALL_OPTIONS: 'raidbots/simbot/toggle_show_all_options',
  SET_OPTIONS_PRESET: 'raidbots/simbot/set_options_preset',
  RESET_ADVANCED_OPTIONS: 'raidbots/simbot/reset_advanced_options',

  TOGGLE_USE_PROFILESETS: 'raidbots/simbot/toggle_use_profilesets',

  // custom apl
  TOGGLE_CUSTOM_APLS: 'raidbots/simbot/toggle_custom_apls',
  INPUT_CUSTOM_APL: 'raidbots/simbot/input_custom_apl',
  CLEAR_CUSTOM_APL: 'raidbots/simbot/clear_custom_apl',

  // report options
  TOGGLE_REPORT_OPTIONS: 'raidbots/simbot/toggle_report_options',
  TOGGLE_REPORT_PAWN_NAME: 'raidbots/simbot/toggle_report_pawn_name',
  TOGGLE_REPORT_PAWN_SPEC: 'raidbots/simbot/toggle_report_pawn_spec',
  TOGGLE_REPORT_PAWN_FIGHT: 'raidbots/simbot/toggle_report_pawn_fight',
  TOGGLE_REPORT_PAWN_DATE: 'raidbots/simbot/toggle_report_pawn_date',
  TOGGLE_REPORT_PAWN_CLASS: 'raidbots/simbot/toggle_report_pawn_class',

  CHOOSE_REPORT_DROPTIMIZER_SORT: 'raidbots/simbot/choose_report_droptimizer_sort',
  TOGGLE_REPORT_DROPTIMIZER_RELATIVE_DPS: 'raidbots/simbot/toggle_report_droptimizer_relative_dps',

  CHOOSE_REPORT_OPTIMIZE_COMPARE_AGAINST: 'raidbots/simbot/choose_report_optimize_compare_against',

  TOGGLE_DETAILED_PROGRESS: 'raidbots/simbot/toggle_detailed_progress',

  // report
  LOAD_GEAR_REPORT: 'raidbots/simbot/load_gear_report',
  LOAD_RELIC_REPORT: 'raidbots/simbot/load_relic_report',
  LOAD_TALENTS_REPORT: 'raidbots/simbot/load_talents_report',
  LOAD_OPTIMIZE_REPORT: 'raidbots/simbot/load_optimize_report',
  LOAD_DROPTIMIZER_REPORT: 'raidbots/simbot/load_droptimizer_report',

  TOGGLE_SHOW_RELATIVE_DIFFERENCE: 'raidbots/simbot/toggle_show_relative_difference',
  TOGGLE_PREFER_EQUIPPED: 'raidbots/simbot/toggle_prefer_equipped',

  // user
  ON_LOGIN_SUCCESS: 'raidbots/on_login_success',
  ON_PREFERENCES_UPDATE: 'raidbots/on_preferences_update',
  ON_SUBSCRIPTION_UPDATE: 'raidbots/on_subscription_update',

  // locale
  SELECT_LOCALE: 'raidbots/select_locale',

  // flash
  FLASH_MESSAGE: 'raidbots/flash_message',
  DISMISS_FLASH: 'raidbots/dismiss_flash',

  // status
  FETCH_STATUS_REQUEST: 'raidbots/status/request',
  FETCH_STATUS_SUCCESS: 'raidbots/status/success',
  FETCH_STATUS_FAILURE: 'raidbots/status/failure',

  ...expansionOptionActionTypes,
};
